module.exports = __webpack_public_path__ + "static/0e70c736.guide-shopify-account.png";